import "antd/dist/antd.css";
import {
  //useContractLoader,
  useUserProviderAndSigner,
} from "eth-hooks";
import React, { useCallback, useEffect, useState } from "react";
/*
import {
  Route,
  Switch,
  useLocation
} from "react-router-dom";*/
import { Header } from "./components";
import { NETWORKS } from "./constants";
import deployedContracts from "./contracts/hardhat_contracts.json";
import {
  Web3ModalSetup,
  //Transactor,
} from "./helpers";
import MintPage from "./views/MintPage";

import "./App.scss";

const { ethers } = require("ethers");

// 📡 What chain are your contracts deployed to?
const initialNetwork = NETWORKS.mainnet; // <------- select your target frontend network (localhost, rinkeby, xdai, mainnet)

// 😬 Sorry for all the console logging
const DEBUG = false;

let web3Modal;

function App(props) {
  // specify all the chains your app is available on. Eg: ['localhost', 'mainnet', ...otherNetworks ]
  // reference './constants.js' for other networks
  const networkOptions = [initialNetwork.name, "mainnet", "rinkeby"];

  const [injectedProvider, setInjectedProvider] = useState();
  const [address, setAddress] = useState();
  //const [writeContracts, setWriteContracts] = useState({});
  const selectedNetwork = networkOptions[0];
  //const location = useLocation();

  const targetNetwork = NETWORKS[selectedNetwork];

  // 🔭 block explorer URL
  const blockExplorer = targetNetwork.blockExplorer;

  if (DEBUG) console.log(`Using ${selectedNetwork} network`);

  const logoutOffWeb3Modal = async () => {
    await web3Modal.clearCachedProvider();
    if (injectedProvider && injectedProvider.provider && typeof injectedProvider.provider.disconnect == "function") {
      await injectedProvider.provider.disconnect();
    }
    setTimeout(() => {
      window.location.reload();
    }, 1);
  };

  // Use your injected provider from 🦊 Metamask or if you don't have it then instantly generate a 🔥 burner wallet.
  const userProviderAndSigner = useUserProviderAndSigner(injectedProvider);  
  const userSigner = userProviderAndSigner.signer;

  useEffect(() => {
    async function getAddress() {
      if (userSigner) {
        const newAddress = await userSigner.getAddress();
        setAddress(newAddress);
      }
    }
    getAddress();
  }, [userSigner]);

  // You can warn the user if you would like them to be on a specific network
  //const localChainId = localProvider && localProvider._network && localProvider._network.chainId;
  const selectedChainId =
    userSigner && userSigner.provider && userSigner.provider._network && userSigner.provider._network.chainId;

  let Phrumps;
  let writeContracts = {};

  if(
    deployedContracts[selectedChainId] &&
    deployedContracts[selectedChainId][selectedNetwork] &&
    deployedContracts[selectedChainId][selectedNetwork].contracts &&
    deployedContracts[selectedChainId][selectedNetwork].contracts.Phrumps
  ) {
    const contractInfo = deployedContracts[selectedChainId][selectedNetwork].contracts.Phrumps;
    Phrumps = new ethers.Contract(contractInfo.address, contractInfo.abi, userSigner);
  }
  writeContracts = {
    Phrumps
  };

  //
  // 🧫 DEBUG 👨🏻‍🔬
  //
  useEffect(() => {
    if (
      DEBUG &&
      address &&
      selectedChainId
    ) {
      console.log("_____________________________________ 🏗 scaffold-eth _____________________________________");
      //console.log("🏠 localChainId", localChainId);
      console.log("👩‍💼 selected address:", address);
      console.log("🕵🏻‍♂️ selectedChainId:", selectedChainId);
    }
  }, [
    address,
    selectedChainId,
    //localChainId,
  ]);

  const loadWeb3Modal = useCallback(async () => {
    const provider = await web3Modal.connect();
    setInjectedProvider(new ethers.providers.Web3Provider(provider));

    provider.on("chainChanged", chainId => {
      setInjectedProvider(new ethers.providers.Web3Provider(provider));
    });

    provider.on("accountsChanged", () => {
      setInjectedProvider(new ethers.providers.Web3Provider(provider));
    });

    // Subscribe to session disconnection
    provider.on("disconnect", (code, reason) => {
      logoutOffWeb3Modal();
    });
    // eslint-disable-next-line
  }, [setInjectedProvider]);

  useEffect(() => {
    if(!web3Modal) {
      web3Modal = Web3ModalSetup()
    }
    if (web3Modal.cachedProvider) {
      loadWeb3Modal();
    }
  }, [loadWeb3Modal]);

  return (
    <div className="App">
      <div className="container">
        <Header
          address={address}
          userSigner={userSigner}
          web3Modal={web3Modal}
          loadWeb3Modal={loadWeb3Modal}
          logoutOfWeb3Modal={logoutOffWeb3Modal}
          blockExplorer={blockExplorer}
        />
        <div className="content">
          <section>
            <p>A Phrump represents a <a href="https://etherscan.io/address/0x1453a8a253ac08b15dbb785bb3bad99bae5fe7ed#code#F1#L77" target="_blank" rel="noreferrer">trustless donation</a> to <a href="https://www.homesnotborders.org/" target="_blank" rel="noreferrer">Homes Not Borders</a>, which helps them <a href="https://www.homesnotborders.org/donate-money/" target="_blank" rel="noreferrer">cover 2022's costs</a> and puts them in a good position for 2023.</p>

            <p>With your donation you get a Phrump! A Phrump gives you control over a record in a mapping in a smart contract on Ethereum where each key is an integer between 1 and 45,000 and the values are addresses. For extra fun, that integer can be used in that same smart contract to look up a URL, and at that URL is a JSON file, and in that JSON file is another URL that points to a flipped version of an image from the Trump Digital Trading Cards NFT collection.</p>

            <p className="center">"I don't know if that's a great prize, but it's what we have."<br/>- Donald Trump</p>

            <div className="img-container center">
              <img className="img" src="https://sylphdapps.com/phrumps/images/sample.png" alt="phrump"/>
            </div>

            <p>If the Trump NFT team takes issue with that, the image URLs will be swapped out for <a href="https://sylphdapps.com/phrumps/images/maybe-gen-art-sample-idk.png" target="_blank" rel="noreferrer">generative art</a> and Phrumps will become there own unique thing.</p>

            <p>#ContigencyPlansNotRoadmaps</p>

            <p>The minimum donation is 0.01 ETH per Phrump but you are welcome to donate more.</p>

            <p>Royalties on secondary sales will accrue to mike.sylphdapps.eth as compensation for the night of sleep he missed setting this up :)</p>
          </section>

          <hr/>
          
          <MintPage
            address={address}
            writeContracts={writeContracts}
            onClickConnect={loadWeb3Modal}
          />

          <hr/>

          <div className="credits">
            <p className="center">Built with ❤️ for memes and good causes by <a href="https://twitter.com/MikeSylphDapps" target="_blank" rel="noreferrer">mike.sylphdapps.eth</a>.</p>
            <p className="center">You can see my other work at <a href="https://sylphdapps.com" target="_blank" rel="noreferrer">Sylph Dapps</a>.</p>
            <p className="center"><a href="https://twitter.com/PhrumpsNFT" target="_blank" rel="noreferrer">Twitter</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href="https://opensea.io/collection/phrumps" target="_blank" rel="noreferrer">OpenSea</a></p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
